jQuery(function ($) {
    var $nav = $('#primary-navigation');
    if (!$nav.length) return;

    var $items = $nav.find('.menu-item-has-children');

    function syncBodyMenuOpen() {
        var $body = $('body');

        var mobileOpen =
            $('#menu-toggle').hasClass('show') ||
            $nav.hasClass('show');

        var dropdownOpen =
            $nav.find('.menu-item-has-children.is-open').length > 0;

        $body.toggleClass('menu-open', mobileOpen || dropdownOpen);
    }

    function closeAllDropdowns() {
        $items.each(function () {
            var $li = $(this);
            var $link = $li.children('a').first();
            var $submenu = $li.children('.sub-menu').first();

            $li.removeClass('is-open');
            $submenu.removeClass('show').attr('aria-hidden', 'true');
            $link.attr('aria-expanded', 'false');
        });

        syncBodyMenuOpen();
    }

    function openDropdown($li) {
        var $link = $li.children('a').first();
        var $submenu = $li.children('.sub-menu').first();

        // Close sibling dropdowns
        $li.siblings('.menu-item-has-children.is-open').each(function () {
            var $sib = $(this);
            $sib.removeClass('is-open');
            $sib.children('.sub-menu').first().removeClass('show').attr('aria-hidden', 'true');
            $sib.children('a').first().attr('aria-expanded', 'false');
        });

        $li.addClass('is-open');
        $submenu.addClass('show').attr('aria-hidden', 'false');
        $link.attr('aria-expanded', 'true');

        syncBodyMenuOpen();
    }

    function toggleDropdown($li) {
        if ($li.hasClass('is-open')) {
            closeAllDropdowns();
        } else {
            openDropdown($li);
        }
    }

    // Init ARIA + IDs
    $items.each(function (i) {
        var $li = $(this);
        var $link = $li.children('a').first();
        var $submenu = $li.children('.sub-menu').first();
        if (!$link.length || !$submenu.length) return;

        var submenuId = $submenu.attr('id');
        if (!submenuId) {
            submenuId = 'sub-menu-' + i;
            $submenu.attr('id', submenuId);
        }

        $link.attr({
            'aria-haspopup': 'true',
            'aria-expanded': 'false',
            'aria-controls': submenuId
        });

        $submenu.attr('aria-hidden', 'true');
    });

    // Click to toggle
    $nav.on('click', '.menu-item-has-children > a', function (e) {
        e.preventDefault();
        var $li = $(this).closest('.menu-item-has-children');
        toggleDropdown($li);
    });

    // Global Escape: closes submenu if any dropdown is open
    $(document).on('keydown', function (e) {
        // Normalize for older browsers just in case
        var key = e.key || e.keyCode;

        var isEscape = (key === 'Escape' || key === 'Esc' || key === 27);
        if (!isEscape) return;

        // Only act if a submenu is currently open
        var $open = $nav.find('.menu-item-has-children.is-open');
        if (!$open.length) return;

        e.preventDefault();
        closeAllDropdowns();

        // Return focus to the trigger of the first open dropdown
        $open.first().children('a').first().trigger('focus');
    });

    // Click outside closes
    $(document).on('click', function (e) {
        var $target = $(e.target);
        if ($target.closest('#primary-navigation').length === 0) {
            closeAllDropdowns();
        }
    });

    // Close all dropdowns
    var navEl = $nav.get(0);
    if (navEl && window.MutationObserver) {
        var observer = new MutationObserver(function () {
            // When primary nav is hidden, close dropdowns
            // When it's shown, re-sync body state
            if (!$nav.hasClass('show')) {
                closeAllDropdowns();
            } else {
                syncBodyMenuOpen();
            }
        });
        observer.observe(navEl, { attributes: true, attributeFilter: ['class'] });
    }

    // Ensure initial state is consistent
    syncBodyMenuOpen();
});
